import { CompanyFinanceContent } from "../../features/companyWorkspace";

function CompanyFinanceScreen() {
  return <CompanyFinanceContent />;
}

export default CompanyFinanceScreen;
